import { CenteredContainer } from 'styles'

export default function NotFound() {
  return (
    <CenteredContainer>
      <b>NOT FOUND :(</b>
    </CenteredContainer>
  )
}
